"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TokenContract_1 = require("./token/TokenContract");
var IdentityToken_1 = require("./token/IdentityToken");
var DeviceToken_1 = require("./token/DeviceToken");
var Errors_1 = require("./Errors");
var utils_1 = require("./utils");
var TokenDecoder = /** @class */ (function () {
    function TokenDecoder(rawToken) {
        var _this = this;
        this.getDecodedToken = function (audience) {
            // verify the token provide the necessary claims
            var decoded = utils_1.decode(_this._rawToken);
            var acrClaim = decoded.claims.acr;
            if (typeof acrClaim === 'undefined') {
                throw new Errors_1.TokenTypeError("UniNow/JWT: The acr claim is missing in the token but it is a required claim.");
            }
            var decodedToken = utils_1.verify({
                idToken: _this._rawToken,
                iss: 'accounts.uninow.com',
                aud: audience,
            });
            switch (acrClaim) {
                case TokenContract_1.TokenTypeEnum.identity:
                    return new IdentityToken_1.IdentityToken(decodedToken, _this._rawToken);
                case TokenContract_1.TokenTypeEnum.device:
                    return new DeviceToken_1.DeviceToken(decodedToken, _this._rawToken);
                default:
                    throw new Errors_1.TokenTypeError("UniNow/JWT: Tokens of type " + acrClaim + " are not supported");
            }
        };
        this._rawToken = rawToken;
    }
    return TokenDecoder;
}());
exports.TokenDecoder = TokenDecoder;
